/** When your routing table is too long, you can split it into small modules **/
const activeMenu = '/dataImportInfo'
const iconName = 'el-icon-circle-plus'
export default [
  {
    path: activeMenu,
    name: 'dataImportInfo',
    alwaysShow: true,
    component: () => import('@/layout/Layout'),
    redirect: '/dataImportInfo/dataImportInfoOverview',
    meta: {
      order: 200,
      icon: iconName,
      title: 'resource.DATA_IMPORT.DATA_IMPORT_INFORMATION'
    },
    //受注データ取込画面
    children: [
    {
        path: 'dataImportInfoOverview',
        component: () => import('@/views/dataImportInfo/dataImportInfo.vue'),
        name: 'dataImportInfoOverview',
        hidden: true,
        meta: {
          order: 201,
          activeMenu: activeMenu,
          icon: iconName,
          //角色：管理者、営業
          permission: ['dataImportInfo'],
          title: 'resource.DATA_IMPORT.DATA_IMPORT_INFORMATION',
        }
      },
    ]
  }
]

